import React from 'react';
import { createRoot } from 'react-dom/client';
import { GasConfirmProvider, GasQueryProvider, GasToastProvider } from '../../shared/kit';
import App from './App';
import type { RentalReserveInitData } from './types';
import './style.css';

const MOUNT_ID = 'gas-rental-reserve-app';

const mountEl = document.getElementById(MOUNT_ID);
if (mountEl?.dataset.reactInit && mountEl.isConnected) {
    let initData: RentalReserveInitData;
    try {
        initData = JSON.parse(mountEl.dataset.reactInit) as RentalReserveInitData;
    } catch (e) {
        console.error('rental-reserve: data-react-init invalid JSON', e);
        throw e;
    }

    createRoot(mountEl).render(
        <React.StrictMode>
            <GasQueryProvider>
                <GasToastProvider>
                    <GasConfirmProvider>
                        <App initData={initData} />
                    </GasConfirmProvider>
                </GasToastProvider>
            </GasQueryProvider>
        </React.StrictMode>,
    );
}
